import React from "react";

function Resume() {
  return (
    <>
      <section id="resume" class="section bg-dark-1">
        <div class="container">
          <div class="section-head ">
          <h2>SUMMARY</h2>
          <h3>
            Resume <span className="border2"> </span>{" "}
          </h3>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="resume-box">  
                <div class="resume-head">
                  <h4>Education</h4>
                </div>

                <div class="resume-content">
                  <div class="resume-item">
                    <h5>.NET Full Stack Development</h5>
                    <h6>2013 - 2014</h6>
                    <p>Noida Sector 15</p>
                  </div>
                </div>

                 <div class="resume-content">
                  <div class="resume-item">
                    <h5>Angular Certification </h5>
                    <h6>2020</h6>
                    <p>Udemy </p>
                  </div>
                </div>

                  <div class="resume-content">
                  <div class="resume-item">
                    <h5>JavaScript Certification </h5>
                    <h6>2022</h6>
                    <p>Hackerrank</p>
                  </div>
                </div>


                <div class="resume-content">
                  <div class="resume-item">
                    <h5>Bachelor of  Computer Application (BCA)</h5>
                    <h6>2007 - 2010</h6>
                    <p>Sikkim Manipal University, Delhi</p>
                  </div>
                </div>

              <div class="resume-content">
                <div class="resume-item">
                  <h5>Intermediate (10+2)</h5>
                  <h6>2005 - 2007</h6>
                  <p> Rajput Inter college, Chappra</p>
                </div>
              </div>
            
<div class="resume-content">
                <div class="resume-item">
                  <h5>High School </h5>
                  <h6>2004 - 2005 </h6>
                  <p> Rajput Inter college, Chappra</p>
                </div>
              </div>
              
                
             


              </div>
            </div>
            <div class="col-md-6">
              <div class="resume-box">
                <div class="resume-head">
                  <h4>Experience</h4>
                </div>
                 <div class="resume-content">
                  <div class="resume-item">
                    <h5>System Engineer </h5>
                    <h6>2026 - TILL</h6>
                    <p>Sinaxis Enterprises Pvt Ltd. (Sena Bhawan, Delhi)</p>
                   
                  </div>
                </div>
                <div class="resume-content">
                  <div class="resume-item">
                    <h5>Senior Frontend Developer (Team Lead)</h5>
                    <h6>2022 - 2026</h6>
                    <p>Esafe Solution, Noida</p>
                   
                  </div>
                </div>
                <div class="resume-content">
                  <div class="resume-item">
                    <h5>Senior UI Developer</h5>    
                    <h6>2018-2022</h6>
                    <p>Edge Fintrack Capital Pvt Ltd, Noida</p>
                    
                  </div>
                </div>

  <div class="resume-content">
                  <div class="resume-item">
                    <h5>Senior Web Designer</h5>    
                    <h6>2016-2018</h6>
                    <p>Genesis Web Solution, Delhi</p>
                    
                  </div>
                </div>

                 <div class="resume-content">
                  <div class="resume-item">
                    <h5>Senior Web Designer</h5>    
                    <h6>08/2014 - 02/2016</h6>
                    <p>It Infocube It Services Pvt Ltd - Gurgaon</p>
                    
                  </div>
                </div>

                 <div class="resume-content">
                  <div class="resume-item">
                    <h5> Web/Graphic Designer</h5>    
                    <h6>03/2013 - 06/2014 </h6>
                    <p>Abeona Web Studio Pvt Ltd. - Noida</p>
                    
                  </div>
                </div>

              </div>
              </div>
            </div>

                 
                    

                <div class="resume-head mt-5 mb-1">
                  <h4>My skills</h4>
                </div>

                 <div class="row">
             
      <div class="col-md-6 pt-2">
            <p className="text-white mb-2 mt-2">React.js <span className="float-end">75%</span></p>
            <div class="progress" role="progressbar" aria-label="info" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar" style={{width: "75%"}}></div>
            </div>

 <p className="text-white mb-2 mt-3">Tailwind CSS <span className="float-end">80%</span></p>
            <div class="progress" role="progressbar" aria-label="info" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar" style={{width: "80%"}}></div>
            </div>

            <p className="text-white mb-2 mt-3">Redux <span className="float-end">60%</span></p>
            <div class="progress" role="progressbar" aria-label="info" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar " style={{width: "60%"}}></div>
            </div>
      
    


<p className="text-white mb-2 mt-3">RestApi <span className="float-end">60%</span></p>
            <div class="progress" role="progressbar" aria-label="info" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar" style={{width: "60%"}}></div>   
</div>

<p className="text-white mb-2 mt-3">Node.js <span className="float-end">50%</span></p>
            <div class="progress" role="progressbar" aria-label="info" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar" style={{width: "50%"}}></div>   
</div>




            </div>
            <div class="col-md-6 pt-2">
       
<p className="text-white mb-2 mt-2">JavaScript ES6 <span className="float-end">80%</span></p>
            <div class="progress" role="progressbar" aria-label="info" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar" style={{width: "80%"}}></div>   
</div>

            <p className="text-white mb-2 mt-3">HTML5 <span className="float-end">95%</span></p>
            <div class="progress" role="progressbar" aria-label="info" aria-valuenow="95" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar" style={{width: "95%"}}></div>
            </div>
            <p className="text-white mb-2 mt-3">CSS3/SCSS <span className="float-end">75%</span></p>
            <div class="progress" role="progressbar" aria-label="info" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar" style={{width: "75%"}}></div>   
</div>

<p className="text-white mb-2 mt-3">Bootstrap <span className="float-end">85%</span></p>
            <div class="progress" role="progressbar" aria-label="info" aria-valuenow="85" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar" style={{width: "85%"}}></div>   
</div>

<p className="text-white mb-2 mt-3">Figma <span className="float-end">60%</span></p>
            <div class="progress" role="progressbar" aria-label="info" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
              <div class="progress-bar" style={{width: "60%"}}></div>   
</div>




   </div>

           

</div>
        </div>
      </section>
    </>
  );
}

export default Resume;
